/**
 * Convertit un `GeneratedVisualBlock` (forme littérale minimale produite par
 * le moteur `generateInstance`, cf. `@jeraisonne/db/blueprint`) en
 * `ExerciseVisualBlock` (`@jeraisonne/ai`) — la forme attendue par
 * `VisualBlockRenderer` et par `data.visuals` d'un bloc `statement` V2.
 *
 * Centralise le seul point de conversion entre les deux types : évite un cast
 * `as` dispersé, et fait apparaître en TypeScript tout drift de forme entre
 * les deux côtés (packages/db reste volontairement indépendant de
 * @jeraisonne/ai).
 */

import type { ExerciseVisualBlock } from '@jeraisonne/ai';
import type { GeneratedVisualBlock } from '@jeraisonne/db/blueprint';

export function toExerciseVisualBlock(visual: GeneratedVisualBlock): ExerciseVisualBlock {
  if (visual.type === 'table') {
    return {
      id: visual.id,
      order: visual.order,
      type: 'table',
      headers: visual.headers ?? undefined,
      rows: visual.rows,
    };
  }

  return {
    id: visual.id,
    order: visual.order,
    type: 'function_graph',
    viewport: visual.viewport,
    functions: visual.functions,
    points: visual.points,
  };
}
